export default __webpack_public_path__ + "static/media/haha.e64e084b.jpg";